/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export const getFiles = (feature: BaseFeature): string[] => {
    return [
        'settings_schema.json',
    ];
};

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    let blocks: Array<CodeBlock> = [];
    const settings = feature.getSettingValue('SETTINGS');


    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.LOCATION,
        id: 'stg_set',
        template: `
function stg_set(name, value) {
    const { type, min, max } = settingsSchema[name];
    if (type === 'F') {
        value = parseFloat(value);
        if (isNaN(value) || value < min || value > max) {
            return;
        }
    }
    if (type === 'S') {
        if (value.length > max || value.length < min) {
            return;
        }
    }
    simulator.settings[name] = value;
    simulator.emit({
        eventType: 'stg_update',
        settings: { ...simulator.settings },
    });
    callback_stg_post_set(name, value)
}`,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.LOCATION,
        template: `
const settingsSchema = {
    /****SETTINGS_SCHEMA****/
}
`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.LOCATION,
        id: 'stg_init',
        template: `
function stg_restore_multiple() {
    const settingsInSchema = Object.keys(settingsSchema);
    for (const setting of settingsInSchema) {
        stg_set(setting, settingsSchema[setting].default);
    }
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.LOCATION,
        id: 'stg_get',
        template: `
function stg_get(name) {
    return simulator.settings[name];
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.LOCATION,
        id: 'callback_stg_post_set',
        template: `
function callback_stg_post_set(stg_name_or_num, stg_value) {
    /****callback_stg_post_set****/

}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.LOCATION,
        id: 'sha256',
        template: `
async function sha256(message) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder('utf-8').encode(message);

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.LOCATION,
        id: 'stg_start',
        template: `
async function stg_start() {
    let init = false;

    const settingsInSchema = Object.keys(settingsSchema);
    if (Object.keys(simulator.settings).length !== settingsInSchema.length) {
        init = true;
    }
    for (const setting of settingsInSchema) {
        const schema = settingsSchema[setting];
        const hash = await sha256(schema.min + schema.max + schema.type);
        if (simulator.settingsHashes[setting] && simulator.settingsHashes[setting] !== hash) {
            console.log("The settings schema has changed. Restoring default values...");
            init = true;
        }
        simulator.settingsHashes[setting] = hash;
    }
    simulator.emit({
        eventType: 'stg_hashes',
        hashes: simulator.settingsHashes,
    });
    if (init) {
        stg_restore_multiple();
    }
}
`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
stg_start();`,
    });

    for (let i = 0; i < settings.length; i += 1) {
        const setting = settings[i];
        const settingBlocks = setting.getCodeBlocks();
        if (i === settings.length - 1) {
            settingBlocks[settingBlocks.length - 1]
                .template = settingBlocks[settingBlocks.length - 1]
                    .template.replace(/,(?=[^,]+$)/, '');
        }
        blocks = blocks.concat(settingBlocks);
    }

    return blocks;
};
